<template>
  <div>
    <v-row dense justify="center">
      <v-col sm="6" md="6">
        <v-autocomplete
          class="no-display"
          :items="stud_list"
          item-value="lid"
          v-model="stud_data"
          item-text="name"
          label="Search Student"
          dense
          rounded
          outlined
          :loading="comp_load"
          placeholder="Search by PRN No or name"
          color="#0F2027"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row dense justify="center" v-if="stud_data != null">
      <v-radio-group v-model="radios1" mandatory row class="ma-2 no-display">
        <v-radio
          label="Student Icard"
          value="stud_icard"
          color="#0f2027"
        ></v-radio>
        <v-radio
          label="Parent Icard"
          value="parent_icard"
          color="#0f2027"
        ></v-radio>
      </v-radio-group>
    </v-row>
    <v-row
      justify="center"
      v-if="stud_data != null && radios1 == 'stud_icard'"
      dense
    >
      <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
        <v-radio label="Both" value="both" color="#0f2027"></v-radio>
        <v-radio label="Front Copy" value="front" color="#0f2027"></v-radio>
        <v-radio label="Back Copy" value="back" color="#0f2027"></v-radio>
      </v-radio-group>
      <v-btn
        @click="icardGenerateStudent()"
        v-if="stud_data != null"
        class="button no-display"
        >Get Icard</v-btn
      >
    </v-row>
    <v-row
      dense-
      justify="center"
      v-if="stud_data != null && radios1 == 'parent_icard'"
    >
      <v-btn @click="call" v-if="stud_data != null" class="button no-display"
        >Get Parent Icard</v-btn
      >
    </v-row>
    <v-row dense>
      <v-btn
        v-if="icard_data != '' && radios1 == 'stud_icard'"
        class="ma-2 no-display"
        tile
        outlined
        color="warning"
        @click="printStudIcard()"
      >
        <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
      </v-btn>
    </v-row>
    <v-row dense justify="center" v-if="radios1 == 'stud_icard'">
      <div v-if="icard_data != '' && radios == 'front'" style="width: 25rem">
        <div class="row box1" style="background-color: white">
          <!-- <v-col cols="12" sm="2" md="2" class="pt-none mt-none"> -->
          <div class="ml-1" style="font-size: 0.9em; width: 60px">
            <img
              class="ml-1 mt-1 pt-0"
              :src="icard_data[0].logo"
              height="60"
              width="auto"
              alt="logo"
            />
          </div>
          <div style="width: 350px">
            <span class="" v-html="icard_data[0].heading">
              {{ icard_data[0].heading }}</span
            >
          </div>
          <v-img
            style="background-color: white"
            height="200px"
            :src="icard_data[0].watermark"
          >
            <hr style="width: 100%" />
            <div class="row">
              <img
                :src="icard_data[0].profile_photo_path"
                class="ml-5 box1 mt-1"
                style="width: 25%; height: 110px"
              />
              <div class="ml-5 mt-1" style="font-size: 0.8em">
                <strong>Academic Year :-</strong> {{ icard_data[0].ay }}<br />
                <strong>Name :-</strong> {{ icard_data[0].name }}<br />
                <strong>Grade :-</strong> {{ icard_data[0].std }}
                <span class="ml-5"
                  ><strong>Div :-</strong> {{ icard_data[0].div }}</span
                >
                <br />
                <strong>House :-</strong> {{ icard_data[0].house }}<br />
                <strong>Contact No. :-</strong> {{ icard_data[0].both_mobile_no
                }}<br />
              </div>
            </div>
            <!-- <div style="position: absolute; bottom: 18px;" class="white--text ml-3"><img :src="icard_data[0].sign" class="pb-3" style="width: 25%; height: 60px;" alt="logo" /></div> -->
            <div style="margin-top: 10px" class="white--text ml-4 sign">
              <img :src="icard_data[0].sign" alt="logo" />
            </div>
            <div
              style="
                position: absolute;
                bottom: 24px;
                text-transform: uppercase;
              "
              class="white--text ml-3"
            >
              <strong> principal </strong>
            </div>
            <div class="bottomright white--text">
              <strong> {{ icard_data[0].grno }}</strong>
            </div>
          </v-img>
        </div>
      </div>
      <span class="ml-10"></span>
      <div v-if="icard_data != '' && radios == 'back'" style="width: 25rem">
        <div class="row box2" style="background-color: white">
          <div class="row">
            <div class="ml-5" style="font-size: 0.7em">
              <!-- <strong>Date of Birth :-</strong> {{icard_data[0].stud_dob}} <span class="bldgrp"><strong>Blood Group :-</strong> {{icard_data[0].stud_blood_group}}</span> <br /> -->
              <!-- <div class="parent"> -->
              <div class="row emailmob1">
                <v-col cols="12" sm="7" md="7">
                  <strong>Date of Birth :-</strong>
                  {{ icard_data[0].stud_dob }}</v-col
                >
                <v-col cols="12" sm="5" md="5"
                  ><span class="bldgrp"
                    ><strong>Blood Group :-</strong>
                    {{ icard_data[0].stud_blood_group }}</span
                  ></v-col
                >
              </div>

              <div class="addrs">
                <strong>Address :-</strong> {{ icard_data[0].stud_address }}
              </div>
              <!-- </div> -->

              <div>
                <strong>Parent Name :-</strong> {{ icard_data[0].parent_name }}
              </div>
              <!-- <strong>Email :-</strong> {{icard_data[0].email}} <span class="mbno"><strong>Mobile No. :-</strong> {{icard_data[0].emergency_contact_number}}</span> <br /> -->
              <div class="row emailmob">
                <v-col cols="12" sm="7" md="7">
                  <strong>Email :-</strong> {{ icard_data[0].email }}</v-col
                >
                <v-col cols="12" sm="5" md="5"
                  ><span class="mbno"
                    ><strong>Mobile No. :-</strong>
                    {{ icard_data[0].emergency_contact_number }}</span
                  ></v-col
                >
              </div>
              <hr style="width: 100%; width: 418px; margin-left: -6px" />
              <strong>Important Points:-</strong>
              <div
                class="row ml-1"
                v-for="(i, index) in icard_data[0].instruction"
                :key="index"
              >
                <strong>{{ index + 1 }}. {{ i.topic }}</strong>
              </div>

              <center>
                <div class="barcode">
                  <barcode
                    height="12"
                    width="2"
                    font-size="13px"
                    v-model="icard_data[0].grno"
                    v-bind:value="icard_data[0].grno"
                  >
                  </barcode>
                </div>
              </center>
            </div>
          </div>
          <div class="row colorcss" style="background: #008ed2">
            <div class="ml-1" style="font-size: 0.7em">
              <!-- <hr  class="hrback"/> -->
              <div class="parent">
                <div class="row ml-5 schladdr">
                  <strong>{{ icard_data[0].school_address }}</strong>
                </div>
                <!-- <div class="row"> -->
                <center>
                  <strong
                    >School Contact No. :-
                    {{ icard_data[0].school_contact }}</strong
                  >
                </center>
                <!-- </div> -->
                <div class="row ml-5 schladdr">
                  <strong
                    >{{ icard_data[0].website }}
                    <span class="ml-5">{{
                      icard_data[0].school_email
                    }}</span></strong
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-row>
    <v-row
      dense
      justify="center"
      v-if="icard_data != '' && radios == 'both' && radios1 == 'stud_icard'"
    >
      <div v-if="icard_data != '' && radios == 'both'" style="width: 25rem">
        <div class="row box1" style="background-color: white">
          <!-- <v-col cols="12" sm="2" md="2" class="pt-none mt-none"> -->
          <div class="ml-1" style="font-size: 0.9em; width: 60px">
            <img
              class="ml-1 mt-1 pt-0"
              :src="icard_data[0].logo"
              height="58"
              width="auto"
              alt="logo"
            />
          </div>
          <div style="width: 350px">
            <span class="" v-html="icard_data[0].heading">
              {{ icard_data[0].heading }}</span
            >
          </div>

          <v-img
            style="background-color: white"
            height="200px"
            :src="icard_data[0].watermark"
          >
            <hr style="width: 100%" />
            <div class="row">
              <img
                :src="icard_data[0].profile_photo_path"
                class="ml-5 box1 mt-1"
                style="width: 25%; height: 110px"
              />
              <div class="ml-5 mt-1" style="font-size: 0.8em">
                <strong>Academic Year :-</strong> {{ icard_data[0].ay }}<br />
                <strong>Name :-</strong> {{ icard_data[0].name }}<br />
                <strong>Grade :-</strong> {{ icard_data[0].std }}
                <span class="ml-5"
                  ><strong>Div :-</strong> {{ icard_data[0].div }}</span
                >
                <br />
                <strong>House :-</strong> {{ icard_data[0].house }}<br />
                <strong>Contact No. :-</strong> {{ icard_data[0].both_mobile_no
                }}<br />
              </div>
            </div>
            <div style="margin-top: 10px" class="white--text ml-4 sign">
              <img :src="icard_data[0].sign" alt="logo" />
            </div>
            <div
              style="
                position: absolute;
                bottom: 24px;
                text-transform: uppercase;
              "
              class="white--text ml-3"
            >
              <strong> principal </strong>
            </div>
            <div class="bottomright white--text">
              <strong> {{ icard_data[0].grno }}</strong>
            </div>
          </v-img>
        </div>
      </div>
      <span class="ml-10"></span>
      <div v-if="icard_data != ''" style="width: 25rem">
        <div class="row box2" style="background-color: white">
          <div class="row">
            <div class="ml-5" style="font-size: 0.7em">
              <!-- <strong>Date of Birth :-</strong> {{icard_data[0].stud_dob}} <span class="bldgrp"><strong>Blood Group :-</strong> {{icard_data[0].stud_blood_group}}</span> <br /> -->
              <!-- <div class="parent"> -->
              <div class="row emailmob1">
                <v-col cols="12" sm="7" md="7">
                  <strong>Date of Birth :-</strong>
                  {{ icard_data[0].stud_dob }}</v-col
                >
                <v-col cols="12" sm="5" md="5"
                  ><span class="bldgrp"
                    ><strong>Blood Group :-</strong>
                    {{ icard_data[0].stud_blood_group }}</span
                  ></v-col
                >
              </div>

              <div class="addrs">
                <strong>Address :-</strong> {{ icard_data[0].stud_address }}
              </div>
              <!-- </div> -->

              <div>
                <strong>Parent Name :-</strong> {{ icard_data[0].parent_name }}
              </div>
              <!-- <strong>Email :-</strong> {{icard_data[0].email}} <span class="mbno"><strong>Mobile No. :-</strong> {{icard_data[0].emergency_contact_number}}</span> <br /> -->
              <div class="row emailmob">
                <v-col cols="12" sm="7" md="7">
                  <strong>Email :-</strong> {{ icard_data[0].email }}</v-col
                >
                <v-col cols="12" sm="5" md="5"
                  ><span class="mbno"
                    ><strong>Mobile No. :-</strong>
                    {{ icard_data[0].emergency_contact_number }}</span
                  ></v-col
                >
              </div>
              <hr class="hrback" />
              <strong>Important Points:-</strong>
              <div
                class="row ml-1"
                v-for="(i, index) in icard_data[0].instruction"
                :key="index"
              >
                <strong>{{ index + 1 }}. {{ i.topic }}</strong>
              </div>

              <center>
                <div class="barcode">
                  <barcode
                    height="12"
                    width="2"
                    font-size="13px"
                    v-model="icard_data[0].grno"
                    v-bind:value="icard_data[0].grno"
                  >
                  </barcode>
                </div>
              </center>
            </div>
          </div>
          <div class="row colorcss" style="background: #008ed2">
            <div class="ml-1" style="font-size: 0.7em">
              <!-- <hr style="width: 100%;" /> -->
              <div class="parent">
                <div class="row ml-5 schladdr">
                  <strong>{{ icard_data[0].school_address }}</strong>
                </div>
                <!-- <div class="row"> -->
                <center>
                  <strong
                    >School Contact No. :-
                    {{ icard_data[0].school_contact }}</strong
                  >
                </center>
                <!-- </div> -->
                <div class="row ml-5 schladdr">
                  <strong
                    >{{ icard_data[0].website }}
                    <span class="ml-5">{{
                      icard_data[0].school_email
                    }}</span></strong
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {
    barcode: VueBarcode,
  },
  data: () => ({
    comp_load: false,
    stud_list: null,
    radios: null,
    radios1: null,
    stud_data: null,
    child_data: null,
    icard_data: [],
  }),
  mounted() {
    this.onload();
  },
  methods: {
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    onload() {
      this.comp_load = true;
      axios
        .post("/admission/getAllStudents1")
        .then((res) => {
          if (res.data.msg == "200") {
            this.stud_list = res.data.stud_list;
          } else {
            alert("Somthing went wrong!!!");
          }
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    call() {
      localStorage.setItem("stud_data", JSON.stringify(this.stud_data));
      // localStorage.setItem("authority", this.authority);
      // let routeData = this.$router.resolve({ name: "sbpps-parent-icard" });
      // window.open(routeData.href, "_blank");
    },
    printStudIcard() {
      localStorage.setItem("stud_data", JSON.stringify(this.stud_data));

      // let routeData = this.$router.resolve({
      //   name: "sbpps-student-icard-print",
      // });
      // window.open(routeData.href, "_blank");
    },
    icardGenerateStudent() {
      const data = {
        stud_data: this.stud_data,
      };
      axios
        .post("/Icard/icardGenerateStudent", data)
        .then((res) => {
          this.icard_data = res.data.icard_data;
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
  },
};
</script>
<style scoped>
@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
    font-size: xx-large !important;
  }
  v-card {
    border: none !important;
  }
  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .pagebreak {
    page-break-before: always !important;
  }
  @page {
    size: A4;
    margin-top: none;
    padding-top: none;
    size: 10.5in 9.5in;
    /* size: 88mm 86.614mm; */
  }
  .border_card {
    border: 2px solid #0f2027 !important;
  }

  /* .sign img{
        width: 23%; 
        height: 50px;
    } */
  .barcode {
    margin-top: -1px;
    margin-bottom: -5px;
    /* margin-bottom: -2px; */
  }
}
.bottomright {
  position: absolute;
  bottom: 24px;
  right: 16px;
  font-size: 18px;
}
.box1 {
  border: 2px solid black;
}

.box2 {
  border: 2px solid black;
  height: 275px;
}
.colorcss {
  /* margin-right: 0.5px; */
  margin-right: 1px;
  margin-left: 1px;
  /* height: 100%; */
}

/* .bldgrp{
        margin-left: 23%;
    } */

/* .mbno{
        margin-left: 10%;
    } */
.emailmob {
  margin-top: -10px;
  margin-bottom: -12px;
}
.emailmob1 {
  margin-top: -10px;
  margin-bottom: -12px;
  /* height: 100%; */
}

.addrs {
  /* height: 100%;  */
  margin-top: -10px;
  margin-right: 5px;
}

.parent {
  margin-bottom: -2px;
}
/* .schladdr{
        height: 100%;
    } */

.barcode {
  margin-top: -1px;
  /* margin-bottom: -5px; */
  margin-bottom: -2px;
}
.sign img {
  width: 70px;
  height: 27px;
}

.hrback {
  width: 100%;
  width: 418px;
  margin-left: -6px;
}
</style>
